import { dataVideoAlt } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoAlt = /*#__PURE__*/createIcon(dataVideoAlt)
export default IconVideoAlt
